import { render, staticRenderFns } from "./PopularizeLaw.vue?vue&type=template&id=48819d34&scoped=true&"
import script from "./PopularizeLaw.vue?vue&type=script&lang=js&"
export * from "./PopularizeLaw.vue?vue&type=script&lang=js&"
import style0 from "./PopularizeLaw.vue?vue&type=style&index=0&id=48819d34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48819d34",
  null
  
)

export default component.exports